// extracted by mini-css-extract-plugin
export default {"menu":"DesktopMenu_menu__sfVQM"};